import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import Img1 from "./img1.png";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img3.png";
import Recpiesimg4 from "../../img6.png";
import Recpiesimg5 from "../../img8.png";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Timer from "../timer.png";
import "../recipe.css";
const Maidavegpizzacones = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Maida Veg Pizza Cones"
        Ul1={
          <ul>
            <li>
              <span className="Bold">Nandi maida (all-purpose flour)</span>
            </li>
            <li>baking powder</li>
            <li>salt</li>
            <li>olive oil</li>
            <li>Water</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>2 cups</li>
            <li>1 teaspoon</li>
            <li>1/2 teaspoon</li>
            <li>1 teaspoon</li>
            <li>as needed for kneading</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>Pizza sauce</li>
            <li>Shredded mozzarella cheese</li>
            <li>Your favorite pizza toppings</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>required amount</li>
            <li>required amount </li>
            <li>e.g. bell peppers</li>
            <li>onions, olives, mushrooms</li>
            {/* <li>required amount</li> */}
          </ul>
        }
        Ol1={
          <ol>
            <li>Preheat your oven to 375°F (190°C).</li>
            <li>
              In a bowl, combine maida, baking powder, salt, and olive oil.
              Gradually add water and knead to form a smooth and soft dough. Let
              it rest for 15-20 minutes.
            </li>
            <li>
              Divide the dough into small portions. Roll each portion into a
              thin, elongated oval shape to resemble a cone.
            </li>
            <li>
              Preheat a flat pan or griddle. Place each rolled dough on the hot
              pan for a few seconds until it puffs up slightly. This will help
              the cones hold their shape.
            </li>
            <li>
              Take each rolled dough and form it into a cone shape, pinching the
              bottom to seal it. You can use a small piece of dough to seal any
              openings.
            </li>
            <li>Place the prepared pizza cones on a baking tray.</li>
            <li>
              Fill each cone with pizza sauce, shredded mozzarella cheese, and
              your favorite pizza toppings.
            </li>
            <li>
              Bake in the preheated oven for about 12-15 minutes or until the
              cones are golden brown and the cheese is melted and bubbly.
            </li>
            <li>
              Remove from the oven and let them cool for a few minutes before
              serving
            </li>
            <li>
              Enjoy your Maida Pizza Cones as a fun and interactive way to savor
              the flavors of pizza!
            </li>
          </ol>
        }
        Item1="Biscuit"
        Item2="Besan Kadhi & Rice"
        Item3="Sooji and Vegitable Cheela"
        Link1="wholeattacookies"
        Link2="besankadhirice"
        Link3="sojivegcheela"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Maida Veg Pizza Cones</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">
              For the Pizza Cone Dough:
            </div>
            <ol>
              <li>
                2 cups{" "}
                <span className="Bold">
                  Nandi maida (all-purpose flour)
                </span>{" "}
              </li>
              <li>1 teaspoon baking powder</li>
              <li>1/2 teaspoon salt</li>
              <li>1 tablespoon olive oil</li>
              <li>Water (as needed for kneading)</li>
            </ol>
          </div>
          <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">
              For the Pizza Cone Filling:
            </div>
            <ol>
              <li>Pizza sauce</li>
              <li>Shredded mozzarella cheese</li>
              <li>
                Your favorite pizza toppings (e.g., bell peppers, onions,
                olives, mushrooms, etc.)
              </li>
            </ol>
          </div>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Maida
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>Preheat your oven to 375°F (190°C).</li>
            <li>
              In a bowl, combine maida, baking powder, salt, and olive oil.
              Gradually add water and knead to form a smooth and soft dough. Let
              it rest for 15-20 minutes.
            </li>
            <li>
              Divide the dough into small portions. Roll each portion into a
              thin, elongated oval shape to resemble a cone.
            </li>
            <li>
              Preheat a flat pan or griddle. Place each rolled dough on the hot
              pan for a few seconds until it puffs up slightly. This will help
              the cones hold their shape.
            </li>
            <li>
              Take each rolled dough and form it into a cone shape, pinching the
              bottom to seal it. You can use a small piece of dough to seal any
              openings.
            </li>
            <li>Place the prepared pizza cones on a baking tray.</li>
            <li>
              Fill each cone with pizza sauce, shredded mozzarella cheese, and
              your favorite pizza toppings.
            </li>
            <li>
              Bake in the preheated oven for about 12-15 minutes or until the
              cones are golden brown and the cheese is melted and bubbly.
            </li>
            <li>
              Remove from the oven and let them cool for a few minutes before
              serving
            </li>
            <li>
              Enjoy your Maida Pizza Cones as a fun and interactive way to savor
              the flavors of pizza!
            </li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/besankadhirice">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">
                  Besan Kadhi & Rice
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/nandimeatmasalacurry">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">
                  Nandi Meat Masala Curry
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/daliakhichadi">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">Dalia Khichadi</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 20 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Maidavegpizzacones;
